import { render, staticRenderFns } from "./ChildEventsDialog.vue?vue&type=template&id=97e0d87a"
import script from "./ChildEventsDialog.vue?vue&type=script&lang=js"
export * from "./ChildEventsDialog.vue?vue&type=script&lang=js"
import style0 from "./ChildEventsDialog.vue?vue&type=style&index=0&id=97e0d87a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports